import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export const ReferenceCard = ({
  reference,
  className,
}: {
  reference: Reference;
  className?: { card?: string };
}) => {
  return (
    <div className={cn('relative col-span-1 h-full w-full', className?.card)}>
      <div
        className={cn(
          'absolute left-4 bottom-4 bg-primary/60 p-4 z-[5]',
          'ea-reference-card__title-banner',
        )}
      >
        <p className="text-lg font-semibold text-white md:text-xl xl:text-2xl">{reference.name}</p>
      </div>
      <Image
        src={reference?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(reference?.image, reference?.name)}
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        className="absolute inset-0 z-0 h-full w-full"
      />
    </div>
  );
};
